/**
 * 発送予定日ツールチップ
 * - 休業日情報を表示するツールチップ機能
 * - BusinessDayCalculatorと連携
 */

(function() {
  'use strict';

  class DeliveryDateTooltip {
    constructor() {
      this.tooltip = null;
      this.overlay = null;
      this.isVisible = false;
      this.isMobile = window.innerWidth < 750;
      
      // 初期化
      this.init();
      
    }

    init() {
      // DOM読み込み完了後に実行
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }

      // リサイズ監視
      window.addEventListener('resize', () => {
        this.isMobile = window.innerWidth < 750;
      });
    }

    setup() {
      // フッターの納期表示要素を取得
      const footerDelivery = document.getElementById('footer-delivery');
      if (footerDelivery) {
        this.wrapDeliveryElement(footerDelivery);
      }

      // モバイルフッターの納期表示要素
      const mobileFooterDelivery = document.getElementById('mobile-footer-delivery');
      if (mobileFooterDelivery) {
        this.wrapDeliveryElement(mobileFooterDelivery);
      }

      // ツールチップとオーバーレイを作成
      this.createTooltip();
      this.createOverlay();

      // ドキュメントクリックで閉じる
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.delivery-tooltip-trigger') && 
            !e.target.closest('.delivery-tooltip')) {
          this.hide();
        }
      });

      // ESCキーで閉じる
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.hide();
        }
      });
    }

    /**
     * 納期表示要素をラップしてアイコンを追加
     */
    wrapDeliveryElement(element) {
      const parent = element.parentNode;
      
      // 既にラップ済みかチェック
      if (parent.classList.contains('footer-delivery-wrapper')) {
        return;
      }

      // ラッパー作成
      const wrapper = document.createElement('span');
      wrapper.className = 'footer-delivery-wrapper delivery-tooltip-trigger';
      
      // 元の要素をラッパーに移動
      parent.insertBefore(wrapper, element);
      wrapper.appendChild(element);

      // アイコン追加
      const icon = document.createElement('span');
      icon.className = 'delivery-info-icon';
      icon.innerHTML = 'i';
      icon.setAttribute('aria-label', '休業日情報を表示');
      wrapper.appendChild(icon);

      // イベントリスナー
      if (this.isMobile) {
        wrapper.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggle(wrapper);
        });
      } else {
        wrapper.addEventListener('mouseenter', () => this.show(wrapper));
        wrapper.addEventListener('mouseleave', () => {
          // ツールチップ内にマウスがある場合は閉じない
          setTimeout(() => {
            if (!this.tooltip.matches(':hover')) {
              this.hide();
            }
          }, 100);
        });
        wrapper.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggle(wrapper);
        });
      }
    }

    /**
     * ツールチップ要素を作成
     */
    createTooltip() {
      this.tooltip = document.createElement('div');
      this.tooltip.className = 'delivery-tooltip';
      this.tooltip.innerHTML = `
        <div class="delivery-tooltip-content">
          <button class="tooltip-close-btn" aria-label="閉じる">×</button>
          <div class="tooltip-header">
            <span class="tooltip-header-icon">📅</span>
            <span class="tooltip-header-title">この期間の休業日</span>
          </div>
          <div class="calculation-period">
            <div class="period-row">
              <span class="period-label">今日</span>
              <span class="period-arrow">→</span>
              <span class="period-value" id="tooltip-start-date">---</span>
            </div>
            <div class="period-row">
              <span class="period-label">発送予定日</span>
              <span class="period-arrow">→</span>
              <span class="period-value" id="tooltip-end-date">---</span>
            </div>
          </div>
          <ul class="holiday-list" id="tooltip-holiday-list">
            <!-- 休業日リストがここに入る -->
          </ul>
          <div class="tooltip-footer">
            <a href="/pages/deliveryday" class="tooltip-link">
              📖 発送予定日について詳しく見る →
            </a>
          </div>
        </div>
      `;

      document.body.appendChild(this.tooltip);

      // 閉じるボタン
      const closeBtn = this.tooltip.querySelector('.tooltip-close-btn');
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.hide();
      });

      // ツールチップ内のホバーで閉じない
      this.tooltip.addEventListener('mouseenter', () => {
        this.isHoveringTooltip = true;
      });
      this.tooltip.addEventListener('mouseleave', () => {
        this.isHoveringTooltip = false;
        if (!this.isMobile) {
          this.hide();
        }
      });
    }

    /**
     * モバイル用オーバーレイを作成
     */
    createOverlay() {
      this.overlay = document.createElement('div');
      this.overlay.className = 'delivery-tooltip-overlay';
      document.body.appendChild(this.overlay);

      this.overlay.addEventListener('click', () => this.hide());
    }

    /**
     * ツールチップを表示
     */
    show(triggerElement) {
      if (this.isVisible) return;

      // 休業日情報を更新
      this.updateHolidayInfo();

      // 位置を計算
      if (!this.isMobile) {
        const rect = triggerElement.getBoundingClientRect();
        this.tooltip.style.position = 'fixed';
        this.tooltip.style.bottom = `${window.innerHeight - rect.top + 12}px`;
        this.tooltip.style.left = `${rect.left + rect.width / 2}px`;
        this.tooltip.style.transform = 'translateX(-50%)';
      }

      this.tooltip.classList.add('visible');
      this.overlay.classList.add('visible');
      this.isVisible = true;
    }

    /**
     * ツールチップを非表示
     */
    hide() {
      this.tooltip.classList.remove('visible');
      this.overlay.classList.remove('visible');
      this.isVisible = false;
    }

    /**
     * 表示/非表示を切り替え
     */
    toggle(triggerElement) {
      if (this.isVisible) {
        this.hide();
      } else {
        this.show(triggerElement);
      }
    }

    /**
     * 休業日情報を更新
     */
    updateHolidayInfo() {
      const listEl = document.getElementById('tooltip-holiday-list');
      const startDateEl = document.getElementById('tooltip-start-date');
      const endDateEl = document.getElementById('tooltip-end-date');

      if (!listEl) return;

      // 今日の日付
      const today = new Date();
      const todayStr = this.formatDateJP(today);

      // 発送予定日を取得
      let deliveryDate = null;
      let deliveryDateStr = '---';

      if (window.priceCalculator && window.priceCalculator.currentSelection) {
        const delivery = window.priceCalculator.currentSelection.delivery;
        
        // オプションによる納期調整を取得
        let leadTimeAdjustment = 0;
        if (window.productOptionsManager && typeof window.productOptionsManager.getOptionAdjustments === 'function') {
          const adjustments = window.productOptionsManager.getOptionAdjustments();
          if (adjustments && typeof adjustments.leadTime === 'number') {
            leadTimeAdjustment = adjustments.leadTime;
          }
        }
        
        // 商品の計算タイプを取得
        const productCalcType = window.productDeliveryCalcType || 'business_days';
        const options = { calcType: productCalcType };

        // BusinessDayCalculatorを使用（loadedがtrueの場合）
        if (window.businessDayCalculator && window.businessDayCalculator.loaded) {
          const result = window.businessDayCalculator.calculateDeliveryDate(delivery, leadTimeAdjustment, options);
          if (result) {
            deliveryDate = result.date;
            deliveryDateStr = result.formatted;
          }
        }
        // BusinessDayCalculatorがまだロードされていない場合のフォールバック
        else if (delivery) {
          const result = this.calculateDeliveryDateFallback(delivery, leadTimeAdjustment, options);
          if (result) {
            deliveryDate = result.date;
            deliveryDateStr = result.formatted;
          }
        }
      }

      // 日付表示を更新
      if (startDateEl) startDateEl.textContent = todayStr;
      if (endDateEl) endDateEl.textContent = deliveryDateStr;

      // 休業日リストを生成
      const holidays = this.getHolidaysBetween(today, deliveryDate);

      if (holidays.length === 0) {
        listEl.innerHTML = `
          <li class="no-holidays">
            <div class="no-holidays-icon">✓</div>
            <div>この期間に休業日はありません</div>
          </li>
        `;
      } else {
        listEl.innerHTML = holidays.map(h => `
          <li class="holiday-item">
            <span class="holiday-date">${h.dateStr}</span>
            <span class="holiday-type ${h.typeClass}">${h.typeName}</span>
          </li>
        `).join('');
      }
    }

    /**
     * 期間内の休業日を取得
     */
    getHolidaysBetween(startDate, endDate) {
      const holidays = [];
      
      if (!endDate) return holidays;

      const current = new Date(startDate);
      current.setHours(0, 0, 0, 0);
      
      const end = new Date(endDate);
      end.setHours(0, 0, 0, 0);

      // BusinessDayCalculatorから休業日情報を取得
      const calculator = window.businessDayCalculator;
      const closedDays = calculator?.settings?.closedDays || ['saturday', 'sunday'];
      

      while (current <= end) {
        const dateStr = this.formatDate(current);
        const dayOfWeek = current.getDay();
        let isHoliday = false;
        let holidayInfo = null;

        // 土日チェック
        if (closedDays.includes('saturday') && dayOfWeek === 6) {
          isHoliday = true;
          holidayInfo = { type: 'weekend', name: '定休日（土曜）' };
        } else if (closedDays.includes('sunday') && dayOfWeek === 0) {
          isHoliday = true;
          holidayInfo = { type: 'weekend', name: '定休日（日曜）' };
        }

        // BusinessDayCalculatorの休日データをチェック
        if (calculator && calculator.holidays) {
          const storedHoliday = calculator.holidays.get(dateStr);
          if (storedHoliday) {
            isHoliday = true;
            holidayInfo = storedHoliday;
          }
        }

        if (isHoliday && holidayInfo) {
          holidays.push({
            date: new Date(current),
            dateStr: this.formatDateJP(current),
            type: holidayInfo.type,
            typeName: this.getHolidayTypeName(holidayInfo),
            typeClass: this.getHolidayTypeClass(holidayInfo.type)
          });
        }

        current.setDate(current.getDate() + 1);
      }

      return holidays;
    }

    /**
     * 休業日タイプの日本語名を取得
     */
    getHolidayTypeName(holidayInfo) {
      if (holidayInfo.name) return holidayInfo.name;

      const typeNames = {
        'national_holiday': '祝日',
        'company_holiday': '会社休業',
        'temporary_closure': '臨時休業',
        'year_end_holiday': '年末年始休業',
        'weekend': '定休日'
      };

      return typeNames[holidayInfo.type] || '休業日';
    }

    /**
     * 休業日タイプのCSSクラスを取得
     */
    getHolidayTypeClass(type) {
      const classMap = {
        'national_holiday': 'national',
        'company_holiday': 'company',
        'temporary_closure': 'company',
        'year_end_holiday': 'year-end',
        'weekend': 'weekend'
      };

      return classMap[type] || 'company';
    }

    /**
     * 日付をYYYY-MM-DD形式でフォーマット（ローカル時間）
     */
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    /**
     * 日付を日本語形式でフォーマット
     */
    formatDateJP(date) {
      const weekdays = ['日', '月', '火', '水', '木', '金', '土'];
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const weekday = weekdays[date.getDay()];
      return `${month}/${day}(${weekday})`;
    }

    /**
     * BusinessDayCalculatorがロードされていない場合のフォールバック計算
     */
    calculateDeliveryDateFallback(deliveryText, leadTimeAdjustment = 0, options = {}) {
      let days = 0;
      let useBusinessDays = true;
      
      // 商品の計算タイプを取得
      const productCalcType = options.calcType || window.productDeliveryCalcType || 'business_days';

      if (deliveryText && deliveryText.includes('当日')) {
        days = 0;
      } else if (deliveryText && deliveryText.includes('翌営業日')) {
        days = 1;
      } else if (deliveryText) {
        // まず「X営業日」をチェック
        const businessDayMatch = deliveryText.match(/(\d+)営業日/);
        if (businessDayMatch) {
          days = parseInt(businessDayMatch[1], 10);
          useBusinessDays = true;
        } else {
          // 次に「X日」をチェック
          const calendarDayMatch = deliveryText.match(/(\d+)日/);
          if (calendarDayMatch) {
            days = parseInt(calendarDayMatch[1], 10);
            // productCalcTypeに基づいて計算方式を決定
            useBusinessDays = productCalcType !== 'calendar_days';
          }
        }
      }

      days += leadTimeAdjustment;

      const today = new Date();
      let targetDate = new Date(today);

      if (useBusinessDays) {
        // 簡易的な営業日計算（土日スキップ）
        let addedDays = 0;
        while (addedDays < days) {
          targetDate.setDate(targetDate.getDate() + 1);
          const dayOfWeek = targetDate.getDay();
          if (dayOfWeek !== 0 && dayOfWeek !== 6) {
            addedDays++;
          }
        }
      } else {
        // 暦日計算
        targetDate.setDate(targetDate.getDate() + days);
      }

      return {
        date: targetDate,
        formatted: this.formatDateJP(targetDate),
        businessDays: days
      };
    }
  }

  // BusinessDayCalculatorにSync版メソッドを追加（既に存在しない場合）
  if (window.businessDayCalculator && !window.businessDayCalculator.calculateDeliveryDateSync) {
    window.businessDayCalculator.calculateDeliveryDateSync = function(deliveryText, leadTimeAdjustment = 0, options = {}) {
      
      let businessDays = 0;
      let useBusinessDays = true; // デフォルトは営業日計算
      
      // 商品の計算タイプを取得（options > window.productDeliveryCalcType > デフォルト）
      const productCalcType = options.calcType || window.productDeliveryCalcType || 'business_days';
      
      if (deliveryText && deliveryText.includes('当日')) {
        businessDays = 0;
      } else if (deliveryText && deliveryText.includes('翌営業日')) {
        businessDays = 1;
      } else if (deliveryText) {
        // まず「X営業日」をチェック
        const businessDayMatch = deliveryText.match(/(\d+)営業日/);
        if (businessDayMatch) {
          businessDays = parseInt(businessDayMatch[1], 10);
          useBusinessDays = true;
        } else {
          // 次に「X日」をチェック
          const calendarDayMatch = deliveryText.match(/(\d+)日/);
          if (calendarDayMatch) {
            businessDays = parseInt(calendarDayMatch[1], 10);
            // productCalcTypeに基づいて計算方式を決定
            useBusinessDays = productCalcType !== 'calendar_days';
          }
        }
      }

      businessDays += leadTimeAdjustment;

      const today = new Date();
      let targetDate;
      
      if (useBusinessDays && typeof this.addBusinessDays === 'function') {
        targetDate = this.addBusinessDays(today, businessDays);
      } else {
        // 暦日計算またはaddBusinessDaysがない場合
        targetDate = new Date(today);
        targetDate.setDate(targetDate.getDate() + businessDays);
      }
      
      // formatDateJPがない場合のフォールバック
      let formattedDate;
      if (typeof this.formatDateJP === 'function') {
        formattedDate = this.formatDateJP(targetDate);
      } else {
        const weekdays = ['日', '月', '火', '水', '木', '金', '土'];
        const month = targetDate.getMonth() + 1;
        const day = targetDate.getDate();
        const weekday = weekdays[targetDate.getDay()];
        formattedDate = `${month}/${day}(${weekday})`;
      }

      return {
        date: targetDate,
        formatted: formattedDate,
        businessDays: businessDays
      };
    };
  }

  // 初期化
  window.deliveryDateTooltip = new DeliveryDateTooltip();

})();

